import { Button, Modal } from 'flowbite-react';
import React from 'react';

const ValidationErrorModal = ({
	isOpen,
	onClose,
	errorText,
}: {
	isOpen: boolean;
	onClose: () => void;
	errorText: string;
}) => {
	return (
		<Modal show={isOpen} size="xl" onClose={onClose} dismissible>
			<Modal.Header>
				<p className="text-2xl font-semibold text-gray-800 dark:text-white">Error</p>
			</Modal.Header>
			<Modal.Body>
				<div className="p-4">
					<p className="text-gray-700 text-lg font-[600] dark:text-gray-200">{errorText}</p>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onClose} color="red">
					Close
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ValidationErrorModal;
